import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  PostJson,
} from "../core/Helper";

export class Customer {}

export class CustomerService {
  static async GetList(params) {
    let result = await PostJson("api/customer/get-customer-list", params);
    return (await result) ?? null;
  }

  static async GetListNew(data, user) {
    let result = await PostJson("/api/customer-new/getlist", {
      data,
      user,
    });
    return result ?? null;
  }
  static async GetItemNew(data, user) {
    let result = await PostJson("/api/customer-new/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static SearchA_Customer = (props) => {
    const [setSearhStateA, dataX, userDetail, targetId, targetName, setParams] =
      props;
    setSearhStateA({
      show: true,
      sql: {
        fields: ["custid itemId", "cust_short itemName"],
        tableName: " brch_customer ",
        defaultCriteria: " del_flag ='n' and brchid=" + userDetail.brchid,
        criteriaFields: ["cust_short"],
        criteriaText: "",
        orderBy: ["seq,custcode,cust_short"],
        maxRows: 3000,
      },
      headerText: "โรงพยาบาล",
      action: (data) => {
        dataX.studyInfo[targetId] = data.itemId;
        dataX.studyInfo[targetName] = data.itemName;
        setParams((pv) => {
          pv[targetId] = data.itemId;
          return { ...pv };
        });
        setSearhStateA({ show: false });
      },
    });
  };
}

export const SearchCustomer = (props, callback) => {
  const [setSearchB, data, setData, userInfo, item] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "custid";
  const displayFieldName = "cust_short";

  setSearchB({
    title: "โรงพยาบาล/คลินิก",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "cust_short",
    sql: {
      fields: ["custid", "custcode", "cust_short"],
      tableName: `brch_customer a `,
      defaultCriteria: ` a.del_flag ='n' and a.brchid=${userInfo.brchid}`,
      criteriaFields: ["a.custcode", "a.cust_name", "a.addr", "a.addr2"],
      criteriaText: "",
      orderBy: ["a.custcode"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: callback
      ? callback
      : (result) => {
          setData((pv) => ({
            ...pv,
            ...DeepMergeObject(
              DotStringToObject(
                item.fieldName + "." + item.searchValueName,
                result[idFieldName]
              ),
              DotStringToObject(
                item.fieldName + "." + item.searchDisplayName,
                result[displayFieldName]
              )
            ),
          }));
          setSearchB((pv) => ({ ...pv, show: false }));
        },
    columns: columns,
  });
};

export const SearchAllCustomer = (props, callback) => {
  const [setSearchB, data, setData, userInfo, item] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "custid";
  const displayFieldName = "cust_short";

  setSearchB({
    title: "โรงพยาบาล/คลินิก",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "cust_short",
    sql: {
      fields: ["custid", "custcode", "cust_short"],
      tableName: `brch_customer a `,
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.custcode", "a.cust_name", "a.addr", "a.addr2"],
      criteriaText: "",
      orderBy: ["a.custcode"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: callback
      ? callback
      : (result) => {
          setData((pv) => ({
            ...pv,
            ...DeepMergeObject(
              DotStringToObject(
                item.fieldName + "." + item.searchValueName,
                result[idFieldName]
              ),
              DotStringToObject(
                item.fieldName + "." + item.searchDisplayName,
                result[displayFieldName]
              )
            ),
          }));
          setSearchB((pv) => ({ ...pv, show: false }));
        },
    columns: columns,
  });
};

const columns = [
  {
    dataField: "custcode",
    text: "รหัส",
    sort: true,
    headerStyle: GetHeaderStyle("120px"),
    style: () => GetNormalStyle("center"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "cust_short",
    text: "ชื่อโรงพยาบาล/คลินิก",
    sort: true,
    headerStyle: GetHeaderStyle("auto"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
];
